// extracted by mini-css-extract-plugin
export default {"honeycombContainer":"NavigationList_honeycombContainer__zgi5N"};